@if (isVisible) {
  <div class="dialog-overlay" (click)="closeDialog()" (keydown.escape)="closeDialog()">
    <div class="dialog-box" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <div class="dialog-body">
        <h3 class="dialog-title">{{ 'NOTES.ADD_NOTE_TITLE' | translate }}</h3>
        <p class="dialog-description">{{ 'NOTES.MODAL_DESCRIPTION' | translate }}</p>
        <div class="form-group">
          <label class="form-label" for="noteContent">{{ 'NOTES.NOTE_CONTENT_LABEL' | translate }}</label>
          <div class="textarea-wrapper">
            <textarea
              id="noteContent"
              class="form-textarea"
              [placeholder]="'NOTES.NOTE_PLACEHOLDER' | translate"
              [(ngModel)]="noteContent"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="dialog-actions">
        <button class="btn-save" [disabled]="!canSubmit" (click)="addNote()">{{ 'NOTES.SAVE' | translate }}</button>
        <button class="btn-cancel" (click)="closeDialog()">{{ 'NOTES.CANCEL' | translate }}</button>
      </div>
    </div>
  </div>
}
